"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchesSomeScopes = matchesSomeScopes;
exports.matchesAllScopes = matchesAllScopes;

function matchesSomeScopes() {
  var allowedScopes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var allowedGates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (_ref) {
    var scopes = _ref.scopes,
        gates = _ref.gates;
    return allowedScopes.some(function (scope) {
      return scopes.includes(scope);
    }) && allowedGates.every(function (gate) {
      return gates.includes(gate);
    });
  };
}

function matchesAllScopes() {
  var allowedScopes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var allowedGates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return function (_ref2) {
    var scopes = _ref2.scopes,
        gates = _ref2.gates;
    return allowedScopes.every(function (scope) {
      return scopes.includes(scope);
    }) && allowedGates.every(function (gate) {
      return gates.includes(gate);
    });
  };
}